import React from "react";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="border-t bg-white">
      <div className="mx-auto max-w-6xl px-4 py-8">
        <div className="flex flex-col items-center justify-between gap-6 md:flex-row">
          
          {/* Brand / Copyright */}
          <div className="text-sm text-gray-600">
            © {new Date().getFullYear()} Trusted Wrench. All rights reserved.
          </div>

          {/* Navigation Links */}
          <nav className="flex flex-wrap items-center gap-6 text-sm font-medium text-gray-700">
            <Link to="/" className="hover:text-gray-900 transition">
              Home
            </Link>
            <Link to="/about" className="hover:text-gray-900 transition">
              About Us
            </Link>
            <Link to="/services" className="hover:text-gray-900 transition">
              Services
            </Link>
            <Link to="/contact" className="hover:text-gray-900 transition">
              Contact Us
            </Link>
          </nav>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
